import { List, Map, fromJS } from 'immutable';

export function bulk(state, { customers }) {
    let items = state.get('list') || Map();

    customers.forEach(customer => {
        let c = (items.get(customer.id) || Map()).mergeIn([ 'data' ], fromJS(customer));
        let firstName  = c.getIn(['data', 'firstName']).has("value") ? c.getIn(['data', 'firstName', 'value']) : c.getIn([ 'data', 'firstName' ]);
        let surname = c.getIn([ 'data', 'surname' ]).has("value") ? c.getIn([ 'data', 'surname', 'value']) : c.getIn([ 'data', 'surname']);
        items = items.set(
            customer.id,
            c.set('name', firstName + ' ' + surname)
        );
    });

    return state.set('list', items);
}
